import { render } from "./SuiviAdressePage.vue?vue&type=template&id=5bd566a8&ts=true"
import script from "./SuiviAdressePage.vue?vue&type=script&lang=ts"
export * from "./SuiviAdressePage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__